<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter1">
<p class="centerImage"><img alt="images" id="pg_14_1" src="images/pg_14_1.jpg"/></p>
<p class="caption">By 1940, with almost half a million men under arms in Abyssinia (Ethiopia), Eritrea, Italian Somaliland and Libya, the Italian dictator Benito Mussolini considered himself the strong man of Africa. (<em class="italic">Author’s Collection</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_01_Chapter1.vue?4ba555f5